// AUTO-GENERATED FILE - DO NOT EDIT
// This file was automatically generated by the XDK build tool.
// Any manual changes will be overwritten on the next generation.
/**
 * Models for trends operations
 */
import type * as Schemas from '../schemas.js';





/**
 * Response for getPersonalized
 * 
 * @public
 */
export type GetPersonalizedResponse = Schemas.Get2UsersPersonalizedTrendsResponse;
/**
 * Response for getAi
 * 
 * @public
 */
export type GetAiResponse = Schemas.Get2AiTrendsIdResponse;
/**
 * Response for getByWoeid
 * 
 * @public
 */
export type GetByWoeidResponse = Schemas.Get2TrendsByWoeidWoeidResponse;